import urlConstants from '~/lib/constants/url.constants';
import api from '~/store/services/api';
import { ENUMERATION_CACHE_TIME } from '~/store/services/enumerations';

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCalendarAccount: build.query<CalendarAccount, void>({
      query: () => ({
        url: urlConstants.calendar.getAccount,
      }),
      keepUnusedDataFor: ENUMERATION_CACHE_TIME,
    }),
  }),
});

export const { useGetCalendarAccountQuery } = userApi;
